import React from 'react';
import IconClose from '../IconClose/IconClose';
import Button from '../Button/Button';

import css from './Toast.module.css';

const Toast = ({ message, onClose, intl }) => {
  if (!message) return null;

  return (
    <div className={css.toast}>
      {message}
      <Button
        rootClassName={css.closeButton}
        onClick={onClose}
        title={intl.formatMessage({ id: 'Modal.close' })}
      >
        <IconClose rootClassName={css.closeIcon} />
      </Button>
    </div>
  );
};

export default Toast;
